import { useEffect, useState } from 'react';
import { useStore } from 'store';
import { Slider } from 'components';
import {
  setSelectedEventType,
  setCurrentStep,
} from 'store/actions/giftTableFlow';
import { fetchEventTypes } from 'store/actions/catalogs';
import './style.scss';
import { useWindowSize } from 'hooks';
import { carouselConfig } from './config';
import { setLoginRedirectSSO } from 'util/navigation';

export default function HomeGifts({ isLoggedIn, setLoginRedirect }) {
  const [formattedEventTypes, setFormattedEventTypes] = useState([[]]);
  const [catalogs, dispatch] = useStore((state) => state.catalogs);
  const [, { isMobile }] = useWindowSize();
  const [eventTypesPerNine, setEventTypesPerNine] = useState([])
  const { eventTypes = [] } = catalogs;

  const handleClickEvent = (eventType) => {
    dispatch(setCurrentStep(2));
    dispatch(
      setSelectedEventType({
        ...eventType,
        labels: eventType.eventTypeLabels,
      })
    );
    setLoginRedirectSSO('crear-mesa', true, isLoggedIn);
  };

  useEffect(() => {
    dispatch(fetchEventTypes(true));
  }, []);

  useEffect(() => {
    if (eventTypes.length > 0) {
      setFormattedEventTypes(eventTypes);
      let lastIndexCaches = 0
      const tempEventTypesPerNine = []
      for (let index = 0; index < eventTypes.length; index++) {
        if (index % 9 === 0 && index > 0) {
          tempEventTypesPerNine.push(eventTypes.slice(lastIndexCaches, index))
          lastIndexCaches = index
        }
      }
      const residue = eventTypes.slice(lastIndexCaches)
      if (residue.length > 0) {
        tempEventTypesPerNine.push(residue)
      }
      setEventTypesPerNine(tempEventTypesPerNine)
    }
  }, [eventTypes, isMobile]);

  const mapListOfEventsToRenderGiftItem = (event) => {
    const { id, name, image } = event;
    const handleClick = () => handleClickEvent(event);

    return (
      <div
        key={id}
        className="HomeGiftsItem d-flex flex-column align-items-center"
        onClick={handleClick}
        onKeyDown={handleClick}
        tabIndex={0}
        role="button"
      >
        <div className="HomeGiftsItem__imgcontainer HomeGiftsItem__imgcontainer--hover d-flex justify-content-center align-items-center">
          <img src={image} alt={name} />
        </div>
        <p className="text-center">{name}</p>
      </div>
    );
  };

  return (
    <section className="HomeGifts" id="eventos">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4 mb-md-0">
            <h2 className="title">Te acompañamos en cualquier evento</h2>
            {
              isMobile ? (
                <Slider {...carouselConfig} >
                  {
                    eventTypesPerNine.map((item, index) => (
                      <div className="HomeGifts__container" key={index}>
                        {
                          item.map(mapListOfEventsToRenderGiftItem)
                        }
                      </div>
                    ))
                  }
                </Slider>
              ) : (
                <div className="HomeGifts__container">
                  {
                    formattedEventTypes.flat().map(mapListOfEventsToRenderGiftItem)
                  }
                </div>
              )
            }
          </div>
          <div className="col-12 HomeGifts__text">
            <p>
              Festeja cualquier evento especial, tu graduación, nuevo hogar, bautizos... en fin.
            </p>
            <p className="HomeGifts__text__red">
              ¡Tenemos la mesa digital perfecta para que tu evento sea inolvidable!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
